import { Visibility } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  MenuItem,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../../utils/routes";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CalendarFilter2 } from "../../../Components/Search/Search";
import AddIcon from "@mui/icons-material/Add";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import {
  useApproveAccountSetupMutation,
  useDeclineAccountSetupMutation,
  useDeleteBookServiceMutation,
  useGetAccountCardDetailsQuery,
  useGetBookingServiceSetupQuery,
} from "../../../../api/financeApi";
import { toast } from "react-toastify";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#F9FAFB",
  fontSize: "14px",
  fontWeight: "500",
  color: "#333",
  borderBottom: "none",
}));

const statusColors = {
  Active: "bg-green-100 text-green-700",
  Inactive: "bg-red-100 text-red-700",
  Maintenance: "bg-yellow-100 text-yellow-700",
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  outline: "none",
  borderRadius: "20px",
};

const SetupAnAccount = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("approve");
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bookingServiceId, setBookingServiceId] = useState();
  const [rowData, setRowData] = useState();
  const addFacilitiesUrl = URL.AddFacilities.replace(":id", bookingServiceId);
  const [anchorEl, setAnchorEl] = useState(null);
  const { data, isLoading } = useGetAccountCardDetailsQuery({
    PageSize: 1000000,
    PageNumber: 1,
    Status: selectedStatus,
  });

  console.log(data?.result);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [onDecline, { isLoading: deleteLoading }] =
    useDeclineAccountSetupMutation();
  const [onApprove, { isLoading: approveLoading }] =
    useApproveAccountSetupMutation();
  const handleDecline = async () => {
    try {
      const res = await onDecline({ id: bookingServiceId.id }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        setOpenModal(false);
      } else {
        toast.error(res?.statusMessage);
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };

  const handleApprove = async () => {
    try {
      const res = await onApprove({ id: bookingServiceId.id }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        setOpenModal(false);
      } else {
        toast.error(res?.statusMessage);
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getStatusDetails = (status) => {
    if (status === "Approved") {
      return {
        color: "bg-green-500 px-4 text-[#fff]", // Approved color
        text: "Approved", // Text to display
      };
    } else if (status === "1") {
      return {
        color: "bg-yellow-500 px-4 text-[#fff]", // Pending color
        text: "Pending", // Text to display
      };
    } else if (status === "7") {
      return {
        color: "bg-red-500 px-4 text-[#fff]", // Declined color
        text: "Declined", // Text to display
      };
    } else if (status === "11") {
      return {
        color: "bg-gray-500 px-4 text-[#fff]", // Cancelled color
        text: "Cancelled", // Text to display
      };
    } else {
      return {
        color: "bg-blue-500 px-4 text-[#fff]", // Default color
        text: "All", // Default text
      };
    }
  };

  const { color, text } = getStatusDetails(selectedStatus);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = data?.result?.filter((row) => {
    const searchTermLower = searchTerm.toLowerCase();

    const matchesSearchTerm =
      row?.cardName?.toLowerCase().includes(searchTermLower) ||
      row?.cardNumber?.toLowerCase().includes(searchTermLower) ||
      row?.accountNumber?.toLowerCase().includes(searchTermLower) ||
      row?.bank?.toLowerCase().includes(searchTermLower);

    return matchesSearchTerm;
  });

  return (
    <RouteLayout title="Service Setup">
      <div className="p-[20px]">
        <div className="mb-[30px] flex justify-between items-center">
          <h1 className="text-[#4B664C] font-[500] text-[30px]">
          Card Setup
          </h1>
          <Button
            variant="contained"
            onClick={() => {
              localStorage.removeItem("selectedAccount");
              navigate("/dashboard/finance/" + URL.AttachAccount);
            }}
            style={{ backgroundColor: "#305F32", color: "#fff" }}
          >
            + New Card 
          </Button>
        </div>
        <div className="p-6 bg-white shadow-md rounded-lg">
          <div className="flex justify-between items-center mb-4">
            <div className="flex justify-between items-center gap-3">
              <div className="flex flex-col">
                <span>Search</span>
                <TextField
                  // label="Search"
                  variant="outlined"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  size="small"
                />
              </div>

              <div className="flex flex-col">
                <span>Status</span>
                <TextField
                  select
                  // label="Status"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  variant="outlined"
                  size="small"
                  sx={{
                    width: 216,
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="1">Pending</MenuItem>
                  <MenuItem value="7">Declined</MenuItem>
                  <MenuItem value="11">Cancelled</MenuItem>
                </TextField>
              </div>
            </div>
          </div>
          <div>{isLoading && <p>Loading...</p>}</div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>Payment Type</StyledTableCell>
                  <StyledTableCell>Department</StyledTableCell>
                  <StyledTableCell>Account Name </StyledTableCell>
                  <StyledTableCell>Account Number</StyledTableCell>
                  <StyledTableCell>Expiry Date</StyledTableCell>
                  {/* <StyledTableCell>Date Created</StyledTableCell> */}
                  {selectedStatus !== "" && (
                    <StyledTableCell>Status</StyledTableCell>
                  )}
                  <StyledTableCell>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData?.map((row, index) => (
                  <TableRow key={row?.id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>
                      {row?.paymentType ?? "---"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row?.departmentType ?? "---"}
                    </StyledTableCell>
                    <StyledTableCell>{row?.cardName ?? "---"}</StyledTableCell>
                    <StyledTableCell>
                      {row?.accountNumber ?? "---"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row?.expiryDate ?? "---"}
                    </StyledTableCell>
                    {selectedStatus !== "" && (
                      <StyledTableCell>
                        <span className={`rounded-full px-2 py-1 ${color}`}>
                          {text}
                        </span>
                      </StyledTableCell>
                    )}

                    <StyledTableCell>
                      <div className="flex items-center">
                        <button
                          onClick={() => {
                            // Navigate to the desired page
                            navigate("/dashboard/finance/Attach-Account");

                            // Store the row object as a JSON string in localStorage
                            localStorage.setItem(
                              "selectedAccount",
                              JSON.stringify(row)
                            );
                          }}
                          className="bg-[#6E9170] rounded-l-md p-1"
                        >
                          <Visibility className="text-[#fff]" />
                        </button>

                        <div
                          onClick={() => {
                            setBookingServiceId(row);
                            setRowData(row);
                          }}
                        >
                          <button
                            onClick={handleClick}
                            className="bg-[#4B664C] p-1 rounded-r-md"
                          >
                            <KeyboardArrowDownIcon className="text-[#fff]" />
                          </button>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div className="p-3 flex flex-col gap-8 h-[196px] w-[285px]">
              <div className="flex gap-3 items-center">
                <img
                  className="w-[14px] h-[14px]"
                  src={editIcon}
                  alt="edit con"
                />
                <div
                  onClick={() => {
                    // Navigate to the desired page
                    navigate("/dashboard/finance/Attach-Account");

                    // Store the row object as a JSON string in localStorage
                    localStorage.setItem(
                      "selectedAccount",
                      JSON.stringify(bookingServiceId)
                    );
                  }}
                  className="text-[#4B664C] hover:text-[#305F32]"
                >
                  Update
                </div>
              </div>
              <div className="flex gap-3 items-center">
                <Visibility className="w-[14px] h-[14px]" />
                <div
                  onClick={() => {
                    // Navigate to the desired page
                    navigate("/dashboard/finance/Attach-Account");

                    // Store the row object as a JSON string in localStorage
                    localStorage.setItem(
                      "selectedAccount",
                      JSON.stringify(bookingServiceId)
                    );
                  }}
                  className="text-[#4B664C] hover:text-[#305F32]"
                >
                  View
                </div>
              </div>
              <div
                onClick={() => {
                  setModalType("approve");
                  handleClose();
                  setOpenModal(true);
                }}
                className="flex gap-3 items-center"
              >
                <div className="w-4 h-4 border bg-[#09c902] rounded-full"></div>
                <button>Approve</button>
              </div>

              <div
                onClick={() => {
                  setModalType("decline");
                  handleClose();
                  setOpenModal(true);
                }}
                className="flex gap-3 items-center"
              >
                <div className="w-4 h-4 border bg-[#fd2727] rounded-full"></div>
                <button>Decline</button>
              </div>
              {/* <div onClick={handleDelete} className="flex gap-3 items-center">
                <img
                  className="w-[14px] h-[14px]"
                  src={bin}
                  alt="delete icon"
                />
                <button disabled={deleteLoading}>
                  {deleteLoading ? "Deleting..." : "Delete"}
                </button>
              </div> */}
            </div>
          </Popover>
          <TablePagination
            component="div"
            count={filteredData?.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            className="mt-4"
          />
        </div>
        <div>
          {/* <Button onClick={handleOpenModal}>Open modal</Button> */}
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            {modalType === "decline" ? (
              <div style={style} className="bg-white rounded-lg w-96 p-6">
                <div className="flex justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-yellow-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v2m0 4h.01M4.21 4.21a10 10 0 1115.58 15.58A10 10 0 014.21 4.21z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-center text-gray-900 mb-2">
                  Decline This Request?
                </h3>
                <p className="text-sm   text-gray-500 mb-4">
                  Please add a comment
                </p>
                <textarea
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
                  placeholder="Enter reason for decline"
                  rows="3"
                  // value={comment}
                  // onChange={(e) => setComment(e.target.value)}
                ></textarea>
                <div className="flex justify-between mt-6">
                  <button
                 onClick={()=>setOpenModal(false)}
                    className="bg-[none] text-gray-700 rounded-md px-4 py-2 hover:bg-gray-400"
                  >
                    No, Cancel
                  </button>
                  <button
                    onClick={handleDecline}
                    className="bg-red-600 text-white rounded-md px-4 py-2 hover:bg-red-700"
                  >
                    Yes, Decline
                  </button>
                </div>
              </div>
            ) : (
              <div style={style} className="bg-white rounded-lg w-96 p-6">
                <div className="flex justify-center mb-4">
                  {/* Warning Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-yellow-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v2m0 4h.01M4.21 4.21a10 10 0 1115.58 15.58A10 10 0 014.21 4.21z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-center text-gray-900 mb-2">
                  Approve This Request?
                </h3>
                <p className="text-sm   text-gray-500 mb-4">
                  Please add a comment
                </p>
                <textarea
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:outline-none"
                  placeholder="Enter reason for decline"
                  rows="3"
                  // value={comment}
                  // onChange={(e) => setComment(e.target.value)}
                ></textarea>
                <div className="flex justify-between mt-6">
                  <button
                 onClick={()=>setOpenModal(false)}
                    className="bg-[none] text-gray-700 rounded-md px-4 py-2 hover:bg-gray-400"
                  >
                    No, Cancel
                  </button>
                  <button
                    onClick={handleApprove}
                    className="bg-green-600 text-white rounded-md px-4 py-2 hover:bg-green-700"
                  >
                    Yes, Approve
                  </button>
                </div>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </RouteLayout>
  );
};

export default SetupAnAccount;
